import './js/header';
import './js/switch';
import './js/mobile-menu';
import './js/login';
import './js/news-fetch-service';
import './js/news-card-markup';
import './js/search';
import './js/categories';
import './js/calendar-service';
import './js/news-gallery';
import './js/add-to-favourite';
import './js/add-to-read';
import './js/weather-service';
import './js/scroll-button';
import './js/error-image';
import './js/pagination';
import './js/registration';
